
import {React, useContext, useState, useEffect } from "react";
import { Outlet } from "react-router";
//import Sidebar from "../../components/Sidebar";
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import { useQuery, gql } from '@apollo/client';
import UserContext from '../../../../../context/UserContext';
import ThemeContext from "../../../../../context/ThemeContext";
import { Link, useNavigate } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button"; 
import { Paginator } from 'primereact/paginator';
import "../../../../../index.css"
//import AgencyDtlMainCoop from './AgencyDtlMainCoop'
//import AgencyCreateCoop from './AgencyCreateCoop'
import { Dialog } from 'primereact/dialog';
import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';
//import HtlHotelRoomClassCoop from "./HtlHotelRoomClassCoop";
//import HtlHotelSeasons from "./HtlHotelSeasons";





import HtlCreditCardMainEdit from "./HtlCreditCardMainEdit";

import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api';
        




//theme
import "primereact/resources/themes/tailwind-light/theme.css";     
    
//core
import "primereact/resources/primereact.min.css";                                       
        


const GET_POST = gql`
  query GetFilteredRules(
    $firmMainCode: String
    $firmSubCode: String
    
  ) {
    tbl_dpr_main(order_by: { dpr_main_code: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
        dpr_dpr_type: { _eq: HMCRC }

        
       
      }
    ) {
     
      dpr_main_code
      dpr_main_name
      dpr_dpr_type
      dpr_main_grp_code
        firm_main_code
        firm_sub_code
        active
       
    
    }
  }
`;








const HtlCreditCardMainList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const { users } = useContext(UserContext);
  const {varCode, setVarCode} = useContext(ThemeContext);
  
  const firmMainCode = users.firmcode;
  const firmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: {
        firmMainCode,
        firmSubCode,
      
    },
  });

  const navigate = useNavigate();

  
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';

  const close_form = messages[currentLocale].close_form;
  const rules_management = messages[currentLocale].rules_management;
 
 
  const search_by_name = messages[currentLocale].search_by_name;
  const main_code = messages[currentLocale].main_code;
  const sub_code = messages[currentLocale].sub_code;
  const new_rule_grp_btn = messages[currentLocale].new_rule_grp_btn;
  const rule_class_title = messages[currentLocale].rule_class_title;
  const rule_type_title = messages[currentLocale].rule_type_title;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const rule_grp_id_title = messages[currentLocale].rule_grp_id_title;
  const detail = messages[currentLocale].detail;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const rule_desc_title = messages[currentLocale].rule_desc_title;
  const administrator = messages[currentLocale].administrator;
  const dashboard = messages[currentLocale].dashboard;
  const rule_grp_title = messages[currentLocale].rule_grp_title;
  const start_date_title = messages[currentLocale].start_date_title;
  const end_date_title = messages[currentLocale].end_date_title;
  const sea_new_per_btn = messages[currentLocale].sea_new_per_btn;


 
  


  


  const items = [{ label: dashboard ,url: "/", target: '_self'}, { label: administrator ,url:"/htl/hotel-adm/main" }, { label: "Depolar"  }];


 

  



  
 
  
  const [displayBasic, setDisplayBasic] = useState(false);
 
  console.log(users.firmcode);

  const [rows1, setRows1] = useState(20); // rows1'i tanımlayın ve başlangıç değeri ayarlayın
const [first1, setFirst1] = useState(0); // first1'i tanımlayın ve başlangıç değeri ayarlayın

const onRowsPerPageChange = (e) => {
  setRows1(e.value); // Görünen kayıt sayısını değiştir
  setFirst1(0); // İlk sayfadan başla
};

const onPageChange = (e) => {
  setFirst1(e.first);
  setRows1(e.rows1);
}

const paginatorLeft = <Button type="button" icon="pi pi-refresh" className="p-button-text" />; // paginatorLeft'i tanımlayın
const paginatorRight = <Button type="button" icon="pi pi-cloud" className="p-button-text" />; // paginatorRight'ı tanımlayın

  
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const filteredFirms = data.tbl_dpr_main.filter((firm) =>
    firm.dpr_main_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const actionTemplate = (rowData) => {
    refetch();
    return (
      <Link to={`/htl/hotel-adm/firm/agencydtlmain-coop/${rowData.firm_main_code_n}`}>
        <button
          type="button"
          title="Open details"
          className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
        >
          <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
            <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z"></path>
          </svg>
        </button>
        
      </Link>
      
    );
      };
      
       
      
      const onClick = () => {
        setVarCode("0");
        setDisplayBasic(true);
        refetch();
      };

      const onClick2 = () => {
        
        setDisplayBasic(true);
        refetch();
      };
      
      const onHide = () => {
        setDisplayBasic(false);
        refetch();
        
      };



  const userAndCreatedAtTemplate = (rowData) => {
    return (
      <div>
        <div className="text-xs">{rowData.create_user}</div>
        <div className="text-xs">{rowData.created_at}</div>
      </div>
    );
  };

  const getStatusLabel = (rowData) => {
    const statusClass = rowData.active
      ? "text-purple-800 font-bold text-sm"
      : "text-gray-500 font-bold text-sm";
  
    return (
      <div className={statusClass}>
      {rowData.active ? (
        <FormattedMessage id={activerec} />
      ) : (
        <FormattedMessage id={inactiverec} />
      )}
    </div>
    );
  };


  return (

    

    
    
    
    <div className="container p-2 mx-auto sm:p-4 dark:text-gray-100">
    <div className="flex justify-between items-center">
      <nav>
        <ul className="flex border-solid mt-3 rounded-md border-b outline-1 mb-5">
          {items.map((item, index) => (
            <li key={index} className={`flex items-center m-1 ${index === items.length - 1 ? 'font-normal' : ''}`}>
              {index !== 0 && <span className={`mx-3 ${index === items.length - 1 ? '' : 'font-light'}`}> &gt; </span>}
              {item.url ? (
                <Link to={item.url}>{item.label}</Link>
              ) : (
                <span>{item.label}</span>
              )}
            </li>
          ))}
        </ul>
      </nav>
      <button onClick={() => navigate(-1)} className="flex text-violet-900 hover:text-violet-200 font-bold">
        {close_form}
      </button>
    </div>
    
  

<div>
  
<Dialog visible={displayBasic} style={{ width: '70vw' }} onHide={onHide} header={"Building"}>
  <div className={`modal-backdrop bg-slate-600  ${displayBasic ? 'block' : 'hidden'}`}></div>
  <div>
    <p>
  <HtlCreditCardMainEdit/> 
    </p>
  </div>
</Dialog>
</div>
          
<div className="card flex ">      
<div className="container p-2 mx-auto ">
      <div className=" w-1/1 text-gray-950 flex gap-4">
        <input
          type="text"
          className="px-2 py-1 border rounded-md"
          placeholder={search_by_name}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      

      <div className="mt-0 flex  w-full justify-end ">
      <Button
  label={"New Warehouse"}
  aria-label="Create"
  className="p-button-sm p-button-outlined bg-purple-800 hover:bg-purple-950 text-white font-semibold rounded-md"
  onClick={onClick}  
/>
        </div>
        </div></div></div>
      <div>
      <div className="card p-3 text-sm text-right border-b border-opacity-20 dark:border-gray-700 dark:bg-gray-900">
        <DataTable
        scrollable scrollHeight="450px" loading={loading}
        stickyHeader={true}
        value={filteredFirms}
        paginator
        responsiveLayout="scroll"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate={currentPageReportTemplate}
        rows={rows1} // Bu satırı verilerinize uygun şekilde ayarlayın
        rowsPerPageOptions={[10, 20, 50]}
        first={first1} // Bu satırı verilerinize uygun şekilde ayarlayın
        onPage={(e) => setFirst1(e.first)} 
        onRowsPerPageChange={(e) => setRows1(e.value)}
      //  paginatorLeft={paginatorLeft}
      //  paginatorRight={paginatorRight}
        tableStyle={{ minWidth: '50rem',  maxHeight: '40rem' }}
        onPageChange={onPageChange}
        
       
        
        >
          <Column className="font-bold text-sm" field="firm_main_code" style={{ textAlign: 'left', width: '8rem' }} header={main_code}></Column>
          <Column className="text-sm" field="firm_sub_code" style={{ textAlign: 'left', width: '8rem' }} header={<span sortable className="font-bold text-gray-900">{sub_code}</span>}></Column>
          <Column className="text-sm" field="dpr_dpr_type" style={{ textAlign: 'left', width: '10rem' }} header={<span className="font-bold text-gray-900">{rule_grp_id_title}</span>}></Column>
          <Column className="text-sm" field="dpr_main_code" style={{ textAlign: 'left', width: '10rem' }} header={<span className="font-bold text-gray-900">{rule_class_title}</span>}></Column>
          
          
          <Column field="dpr_main_name"
           className="text-sm text-right" 
           header={<span className="font-bold sortable text-gray-900">{rule_desc_title}</span>}
           style={{ textAlign: 'left', width: '16rem' }}
          >
          </Column>
         
          
          <Column
           field="start_date"
           header={<span className="font-bold text-sm text-gray-900">{start_date_title}</span>}
           body={(rowData) => {
           const dateTimeString = rowData.start_date;
           const dateObj = new Date(dateTimeString);
           const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
           const formattedDate = `${dateObj.toLocaleDateString('en-GB', options)} `;
           

          return (
           <div className="text-sm">
           {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'left', width: '10rem' }}
           />

<Column
           field="end_date"
           header={<span className="font-bold text-sm text-gray-900">{end_date_title}</span>}
           body={(rowData) => {
           const dateTimeString = rowData.end_date;
           const dateObj = new Date(dateTimeString);
           const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
           const formattedDate = `${dateObj.toLocaleDateString('en-GB', options)} `;
           // const createUser = rowData.end_date;

          return (
           <div className="text-sm">
           {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'left', width: '10rem' }}
           />
           <Column
            field="active"
            body={getStatusLabel}
            header={<span className="font-bold text-gray-900">{statusrec}</span>}
            style={{ textAlign: 'center', width: '6rem' }}
            className="font-bold text-sm" 
          />
          <Column
          header={<span className="font-bold text-sm text-gray-900">{detail}</span>}
          body={(rowData) => (
            <button
              onClick={() => {               
                setVarCode(rowData.dpr_main_code);               
                onClick2();
              
                
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>
    
        </DataTable>
        
      </div>
    </div>
    </div>
 
  );
};

export default HtlCreditCardMainList;


